import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BeneficiaryDetailsChanges } from '../../models/beneficiary-details-changes';
import { BeneficiarySubmissionUtils } from '../../utils/beneficiary-submission-utils';
import { SubmissionDetailsFieldChange } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change';
import { SubmissionDetailsFieldChangesComponent } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-changes.component';
import { SubmissionDetailsFieldChangeTypeEnum } from '../../../../views/shared/components/submission-details-field-changes/submission-details-field-change-type.enum';

@Component({
  selector: 'app-beneficiary-details-individual-changes',
  standalone: true,
  imports: [CommonModule, SubmissionDetailsFieldChangesComponent],
  templateUrl: './beneficiary-details-individual-changes.component.html',
  styleUrls: [
    '../../../../views/shared/components/member-beneficiary-submission-details/member-beneficiary-submission-details.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BeneficiaryDetailsIndividualChangesComponent implements OnChanges {
  private static readonly personalKeys = ['relationshipToMember', 'birthDate', 'socialInsuranceNumber'];
  private static readonly contactKeys = [
    'email',
    'phoneNumber',
    'address.addressLine1',
    'address.addressLine2',
    'address.addressLine3',
    'address.city',
    'address.state',
    'address.country',
    'address.postalCode'
  ];

  @Input() beneficiaryChanges!: BeneficiaryDetailsChanges;

  public personalPrevious: SubmissionDetailsFieldChange[] = [];
  public personalNew: SubmissionDetailsFieldChange[] = [];
  public personalPreviousNotApplicable = false;
  public personalNewNotApplicable = false;

  public contactPrevious: SubmissionDetailsFieldChange[] = [];
  public contactNew: SubmissionDetailsFieldChange[] = [];
  public contactPreviousNotApplicable = false;
  public contactNewNotApplicable = false;

  public ngOnChanges(): void {
    const { previous, new: newChanges } = this.beneficiaryChanges;

    const personalPrevious = BeneficiarySubmissionUtils.toDetailsSection(
      previous,
      BeneficiaryDetailsIndividualChangesComponent.personalKeys
    );
    const personalNew = BeneficiarySubmissionUtils.toDetailsSection(
      newChanges,
      BeneficiaryDetailsIndividualChangesComponent.personalKeys
    );
    this.personalPrevious = personalPrevious.items;
    this.personalNew = personalNew.items;
    this.personalPreviousNotApplicable = personalPrevious.notApplicable;
    this.personalNewNotApplicable = personalNew.notApplicable;

    const contactPrevious = BeneficiarySubmissionUtils.toDetailsSection(
      previous,
      BeneficiaryDetailsIndividualChangesComponent.contactKeys
    );
    const contactNew = BeneficiarySubmissionUtils.toDetailsSection(
      newChanges,
      BeneficiaryDetailsIndividualChangesComponent.contactKeys
    );
    this.contactPrevious = contactPrevious.items;
    this.contactNew = contactNew.items;
    this.contactPreviousNotApplicable = contactPrevious.notApplicable;
    this.contactNewNotApplicable = contactNew.notApplicable;
  }

  protected readonly SubmissionDetailsFieldChangeTypeEnum = SubmissionDetailsFieldChangeTypeEnum;
}
